var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 27,
    viewBox: "0 0 31 27",
    fill: "#2C5282",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 0H8C3.86 0 0.5 3.01201 0.5 6.72636V14.8034V16.1541C0.5 19.8684 3.86 22.8804 8 22.8804H10.25C10.655 22.8804 11.195 23.1236 11.45 23.4207L13.7 26.1086C14.69 27.2971 16.31 27.2971 17.3 26.1086L19.55 23.4207C19.835 23.083 20.285 22.8804 20.75 22.8804H23C27.14 22.8804 30.5 19.8684 30.5 16.1541V6.72636C30.5 3.01201 27.14 0 23 0ZM9.5 13.5068C8.66 13.5068 8 12.8989 8 12.1561C8 11.4132 8.675 10.8054 9.5 10.8054C10.325 10.8054 11 11.4132 11 12.1561C11 12.8989 10.34 13.5068 9.5 13.5068ZM15.5 13.5068C14.66 13.5068 14 12.8989 14 12.1561C14 11.4132 14.675 10.8054 15.5 10.8054C16.325 10.8054 17 11.4132 17 12.1561C17 12.8989 16.34 13.5068 15.5 13.5068ZM21.5 13.5068C20.66 13.5068 20 12.8989 20 12.1561C20 11.4132 20.675 10.8054 21.5 10.8054C22.325 10.8054 23 11.4132 23 12.1561C23 12.8989 22.34 13.5068 21.5 13.5068Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.87d1f1a782339e6ef76cf997c6b96863.svg";
export { ForwardRef as ReactComponent };